import * as React from 'react'
import { Rectangle, RectangleProps } from 'recharts'

import { ChartWrapperContext } from './ChartWrapper'

interface CustomCursorProps extends Partial<Omit<RectangleProps, 'points'>> {
  points?: [{ x: number; y: number }]
}

export function CursorBar({
  numberOfDatapoints,
  points,
  ...props
}: CustomCursorProps & { numberOfDatapoints: number }) {
  const isActive = React.useContext(ChartWrapperContext)

  if (!isActive) return null

  const cursorWidth = props.width! / numberOfDatapoints
  const x = points![0].x - cursorWidth / 2
  const y = points![0].y
  return (
    <Rectangle
      {...props}
      x={x}
      y={y}
      width={cursorWidth}
      className="fill-gray-50/65 stroke-none dark:fill-gray-700/65"
    />
  )
}

export function CursorLine({ points, ...props }: CustomCursorProps) {
  const isActive = React.useContext(ChartWrapperContext)

  if (!isActive) return null

  const x = points![0].x - 1
  const y = points![0].y
  return <Rectangle {...props} x={x} y={y} width={1} className="fill-gray-500 stroke-none dark:fill-gray-300" />
}
